(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/service/EditorContextHelper.js":
/*!********************************************!*\
  !*** ./src/service/EditorContextHelper.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "inEditor": () => (/* binding */ inEditor),
/* harmony export */   "inEditorAsync": () => (/* binding */ inEditorAsync),
/* harmony export */   "inEditorPreview": () => (/* binding */ inEditorPreview),
/* harmony export */   "inIframe": () => (/* binding */ inIframe),
/* harmony export */   "inPreviewAsVisitor": () => (/* binding */ inPreviewAsVisitor),
/* harmony export */   "isPageEditorReady": () => (/* binding */ isPageEditorReady),
/* harmony export */   "isRenderingAnnotation": () => (/* binding */ isRenderingAnnotation),
/* harmony export */   "isSameOrigin": () => (/* binding */ isSameOrigin),
/* harmony export */   "onFrameReady": () => (/* binding */ onFrameReady),
/* harmony export */   "refresh": () => (/* binding */ refresh),
/* harmony export */   "setServerUrl": () => (/* binding */ setServerUrl)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _GetMagnoliaContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./GetMagnoliaContext */ "./src/service/GetMagnoliaContext.js");




var isSameOrigin = function isSameOrigin() {
  try {
    var href = window.parent.location.href;
    return href != null;
  } catch (error) {
    return false;
  }
};
function getWindowInstance() {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return isSameOrigin() ? window.parent : window;
}
var context = {
  serverUrl: isSameOrigin() && typeof window !== 'undefined' ? getWindowInstance().location.href : ''
};
var sleep = function sleep(ms) {
  return new Promise(function (r) {
    setTimeout(r, ms);
  });
};
var waitFor = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee(f) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (f()) {
            _context.next = 5;
            break;
          }
          _context.next = 3;
          return sleep(200);
        case 3:
          _context.next = 0;
          break;
        case 5:
          return _context.abrupt("return", f());
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function waitFor(_x) {
    return _ref.apply(this, arguments);
  };
}();
var inIframe = function inIframe() {
  if (typeof window !== 'undefined') {
    return window !== window.parent;
  }
  if ((typeof __webpack_require__.g === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(__webpack_require__.g)) === 'object') {
    if ( true && __webpack_require__.g.mgnlInPageEditor === undefined) {
      // eslint-disable-next-line no-console
      console.log('For SSR, please set \'global.mgnlInPageEditor\' to true when you need to render edit bars, and false when not.');
    }
    return Boolean(__webpack_require__.g.mgnlInPageEditor);
  }
  return false;
};
var inPreviewAsVisitor = function inPreviewAsVisitor() {
  if (typeof window === 'undefined') {
    return (typeof __webpack_require__.g === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(__webpack_require__.g)) === 'object' ? __webpack_require__.g.mgnlPreviewAsVisitor : false;
  }
  return inIframe() && new URLSearchParams(window.location.search).get('mgnlPreviewAsVisitor') === 'true';
};

/**
 * @deprecated Since version 1.1.0. Use inEditorAsync instead.
 */
var inEditor = function inEditor() {
  return inIframe() && context.serverUrl.endsWith(':edit');
};
var inEditorAsync = /*#__PURE__*/function () {
  var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee2() {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.t0 = inIframe();
          if (!_context2.t0) {
            _context2.next = 5;
            break;
          }
          _context2.next = 4;
          return waitFor(function () {
            return context.serverUrl.length > 0;
          });
        case 4:
          _context2.t0 = _context2.sent;
        case 5:
          if (!_context2.t0) {
            _context2.next = 7;
            break;
          }
          return _context2.abrupt("return", context.serverUrl.endsWith(':edit'));
        case 7:
          return _context2.abrupt("return", false);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function inEditorAsync() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * @deprecated Since version 1.1.0. Use inEditorAsync instead.
 */
var inEditorPreview = function inEditorPreview() {
  return inIframe() && context.serverUrl.endsWith(':view');
};

/**
 * @deprecated Since version 1.1.0. Use inEditorAsync instead.
 */
var isRenderingAnnotation = function isRenderingAnnotation() {
  return inIframe() && (inEditor() || !context.serverUrl);
};
var refreshTimeoutID = null;
var refresh = function refresh(delayInMilliseconds) {
  if (refreshTimeoutID) {
    clearTimeout(refreshTimeoutID);
  }
  refreshTimeoutID = setTimeout(callMgnlRefresh, delayInMilliseconds);
};
var callMgnlRefresh = function callMgnlRefresh() {
  var windowInstance = getWindowInstance();
  if (inIframe() && windowInstance.mgnlRefresh) {
    if (document.documentElement.innerHTML.indexOf('cms:page content=') > -1) {
      windowInstance.mgnlRefresh();
    } else {
      refresh(200);
    }
  }
};
var isPageEditorReady = function isPageEditorReady() {
  var windowInstance = getWindowInstance();
  return windowInstance.mgnlFrameReady !== undefined;
};
var onFrameReady = function onFrameReady() {
  var windowInstance = getWindowInstance();
  if (inIframe() && windowInstance.mgnlFrameReady) {
    windowInstance.mgnlFrameReady();
  }
};
var setServerUrl = function setServerUrl(url) {
  context.serverUrl = url;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  inEditor: inEditor,
  inEditorAsync: inEditorAsync,
  inEditorPreview: inEditorPreview,
  inIframe: inIframe,
  isRenderingAnnotation: isRenderingAnnotation,
  isSameOrigin: isSameOrigin,
  refresh: refresh,
  setServerUrl: setServerUrl,
  isPageEditorReady: isPageEditorReady,
  onFrameReady: onFrameReady,
  inPreviewAsVisitor: inPreviewAsVisitor,
  getMagnoliaContext: _GetMagnoliaContext__WEBPACK_IMPORTED_MODULE_3__["default"]
});

/***/ }),

/***/ "./src/service/GetMagnoliaContext.js":
/*!*******************************************!*\
  !*** ./src/service/GetMagnoliaContext.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getMagnoliaContext)
/* harmony export */ });
function getUrl(string) {
  try {
    var url = /^http(s?):\/\//i.test(string) ? string : 'http://valid-url.com' + (string.startsWith('/') ? string : '/' + string);
    return new URL(url);
  } catch (e) {
    console.warn('requestUrl is not a valid URL'); // eslint-disable-line no-console

    return false;
  }
}
function getMagnoliaContext(requestUrl, spaRootNodePath, languages) {
  var url = getUrl(requestUrl);
  var magnoliaContext = {
    isMagnolia: false,
    isMagnoliaEdit: false,
    isMagnoliaPreview: false,
    version: undefined,
    nodePath: undefined,
    currentLanguage: undefined,
    searchParams: undefined,
    search: undefined
  };
  if (url) {
    var pathname = url.pathname;
    var searchParams = new URLSearchParams(url.search);
    var mgnlPreview = searchParams.get('mgnlPreview');
    var mgnlPreviewAsVisitor = searchParams.get('mgnlPreviewAsVisitor');
    var mgnlVersion = searchParams.get('mgnlVersion');
    var preview = mgnlPreview == null ? mgnlPreviewAsVisitor : mgnlPreview;
    if (preview) {
      magnoliaContext.isMagnolia = true;
      if (preview === 'false') {
        magnoliaContext.isMagnoliaEdit = true;
      }
      if (preview === 'true') {
        magnoliaContext.isMagnoliaPreview = true;
      }
    }
    if (magnoliaContext.isMagnolia && !mgnlPreviewAsVisitor) {
      searchParams.set('variants', 'all');
    }
    if (mgnlVersion) {
      magnoliaContext.version = mgnlVersion;
      searchParams.set('version', mgnlVersion);
    } else {
      delete magnoliaContext.version;
    }
    if (languages) {
      magnoliaContext.currentLanguage = languages[0];
      languages.some(function (language) {
        // eslint-disable-line func-names
        if (new RegExp('/' + language + '($|/)').test(pathname)) {
          magnoliaContext.currentLanguage = language;
          return true;
        }
        return false;
      });
      searchParams.set('lang', magnoliaContext.currentLanguage);
    }
    if (spaRootNodePath) {
      magnoliaContext.nodePath = spaRootNodePath + pathname.replace(new RegExp('(.*' + spaRootNodePath + '|.html|/$)', 'g'), '');
      if (magnoliaContext.currentLanguage) {
        magnoliaContext.nodePath = magnoliaContext.nodePath.replace(new RegExp('/' + magnoliaContext.currentLanguage + '($|/)'), '/');
      }
      if (magnoliaContext.nodePath.slice(-1) === '/') magnoliaContext.nodePath = magnoliaContext.nodePath.slice(0, -1);
    }
    magnoliaContext.searchParams = Object.fromEntries(searchParams);
    magnoliaContext.search = '?' + searchParams.toString();
  }
  return magnoliaContext;
}

/***/ }),

/***/ "./src/service/LoggerService.js":
/*!**************************************!*\
  !*** ./src/service/LoggerService.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "error": () => (/* binding */ error),
/* harmony export */   "info": () => (/* binding */ info),
/* harmony export */   "log": () => (/* binding */ log),
/* harmony export */   "warn": () => (/* binding */ warn)
/* harmony export */ });
/* eslint-disable default-param-last */
function exec() {
  var fnName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'log';
  var message = arguments.length > 1 ? arguments[1] : undefined;
  if (typeof console === 'undefined') {
    return;
  }
  // eslint-disable-next-line no-console
  for (var _len = arguments.length, optionalParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    optionalParams[_key - 2] = arguments[_key];
  }
  console[fnName](message, optionalParams);
}
var log = function log(message) {
  for (var _len2 = arguments.length, optionalParams = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    optionalParams[_key2 - 1] = arguments[_key2];
  }
  exec('log', message, optionalParams);
};
var info = function info(message) {
  for (var _len3 = arguments.length, optionalParams = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    optionalParams[_key3 - 1] = arguments[_key3];
  }
  exec('info', message, optionalParams);
};
var warn = function warn(message) {
  for (var _len4 = arguments.length, optionalParams = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    optionalParams[_key4 - 1] = arguments[_key4];
  }
  exec('warn', message, optionalParams);
};
var error = function error(message) {
  for (var _len5 = arguments.length, optionalParams = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    optionalParams[_key5 - 1] = arguments[_key5];
  }
  exec('error', message, optionalParams);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  log: log,
  info: info,
  warn: warn,
  error: error
});

/***/ }),

/***/ "./src/service/PageEditorBridge.js":
/*!*****************************************!*\
  !*** ./src/service/PageEditorBridge.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "getBaseServerUrl": () => (/* binding */ getBaseServerUrl),
/* harmony export */   "init": () => (/* binding */ init),
/* harmony export */   "onMessage": () => (/* binding */ onMessage),
/* harmony export */   "requestServerUrl": () => (/* binding */ requestServerUrl)
/* harmony export */ });
/* harmony import */ var _EditorContextHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./EditorContextHelper */ "./src/service/EditorContextHelper.js");

var listeners = {};
var onMessage = function onMessage(action, callback) {
  if (!action || typeof callback !== 'function') {
    return;
  }
  var actionLowerCase = action.toLowerCase();
  listeners[actionLowerCase] = listeners[actionLowerCase] || [];
  listeners[actionLowerCase].push(callback);
};
function getBaseServerUrl(serverUrl) {
  var url = new URL(serverUrl);
  return "".concat(url.protocol, "//").concat(url.hostname).concat(url.port ? ":".concat(url.port) : '').concat(url.pathname.substring(0, url.pathname.indexOf('.magnolia')));
}
function getActionListeners(action) {
  if (!action) {
    return [];
  }
  return listeners[action.toLowerCase()] || [];
}
function registerPageEditor(callback, serverUrl) {
  var id = 'mgnlPageEditorBridge';
  var bridgeScript = document.getElementById(id);
  if (bridgeScript || !serverUrl) {
    if (typeof callback === 'function') {
      callback();
    }
    return;
  }
  var hostUrl = getBaseServerUrl(serverUrl);
  var firstScript = document.getElementsByTagName('script')[0];
  bridgeScript = document.createElement('script');
  bridgeScript.id = id;
  bridgeScript.src = "".concat(hostUrl, "VAADIN/widgetsets/info.magnolia.PageEditor/info.magnolia.PageEditor.nocache.js");
  firstScript.parentNode.insertBefore(bridgeScript, firstScript);
  bridgeScript.onload = function () {
    // Wait for the page editor is ready and call necessary functions
    setTimeout(function waitAndCall() {
      if (_EditorContextHelper__WEBPACK_IMPORTED_MODULE_0__["default"].isPageEditorReady()) {
        _EditorContextHelper__WEBPACK_IMPORTED_MODULE_0__["default"].onFrameReady();
        _EditorContextHelper__WEBPACK_IMPORTED_MODULE_0__["default"].refresh();
        if (typeof callback === 'function') {
          callback();
        }
      } else {
        setTimeout(waitAndCall, 100);
      }
    }, 50);
  };
  var style = document.createElement('link');
  style.href = "".concat(hostUrl, "VAADIN/themes/pages-app/page-editor.css");
  style.type = 'text/css';
  style.rel = 'stylesheet';
  document.head.insertBefore(style, document.head.firstChild);
}
var requestServerUrl = function requestServerUrl() {
  var notifyMessage = {
    element: {
      dialog: '',
      path: '/',
      workspace: 'website'
    },
    action: 'initialize',
    elementType: 'page'
  };
  window.parent.postMessage(JSON.stringify(notifyMessage), '*');
};
var init = function init(callback) {
  if (typeof window === 'undefined' || _EditorContextHelper__WEBPACK_IMPORTED_MODULE_0__["default"].isSameOrigin()) {
    return;
  }
  window.addEventListener('message', function (event) {
    if (!event.data || !(typeof event.data === 'string' && event.data.startsWith('{'))) return;
    var message = JSON.parse(event.data);
    var actionListeners = getActionListeners(message.action);
    actionListeners.forEach(function (listener) {
      try {
        listener(message);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    });
  });
  onMessage('updateState', function (message) {
    var serverUrl = message.serverUrl;
    _EditorContextHelper__WEBPACK_IMPORTED_MODULE_0__["default"].setServerUrl(serverUrl);
    registerPageEditor(callback, serverUrl);
  });
  requestServerUrl();
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  init: init,
  onMessage: onMessage,
  requestServerUrl: requestServerUrl
});

/***/ }),

/***/ "./src/service/PersonalizationService.js":
/*!***********************************************!*\
  !*** ./src/service/PersonalizationService.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "getSelectedVariant": () => (/* binding */ getSelectedVariant),
/* harmony export */   "getVariant": () => (/* binding */ getVariant),
/* harmony export */   "wrap": () => (/* binding */ wrap)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var _EditorContextHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./EditorContextHelper */ "./src/service/EditorContextHelper.js");
/* harmony import */ var _LoggerService__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./LoggerService */ "./src/service/LoggerService.js");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var getSelectedVariant = function getSelectedVariant(content, templateAnnotations) {
  if (!content || !templateAnnotations) {
    return content;
  }
  var annotations = templateAnnotations[content === null || content === void 0 ? void 0 : content['@path']];
  var match = annotations ? annotations.match(/selectedVariant="(.+)"/) : null;
  if (!match) return content;
  var variant = match[1];
  return variant === content['@name'] ? content : content[variant];
};
var getVariant = function getVariant(content, templateAnnotations) {
  if (!_EditorContextHelper__WEBPACK_IMPORTED_MODULE_2__["default"].inIframe() || _EditorContextHelper__WEBPACK_IMPORTED_MODULE_2__["default"].inPreviewAsVisitor()) {
    return content;
  }
  return getSelectedVariant(content, templateAnnotations);
};

/**
 * Wrap template annotations in order to resolve personalized content.
 *
 * Search for 'selectedVariant' in the template annotations and try to replace the value
 * of the aforementioned attribute with selected one by the variant select.
 *
 * Server does not know which variant was selected, thus we store it in the client app session on
 * variant select change.
 */
var wrap = function wrap(templateAnnotations, selectedComponentVariants) {
  if (!selectedComponentVariants) {
    return templateAnnotations;
  }
  var modified = {};
  var selectedVariantRegex = /selectedVariant="(.+?)"/;
  var contentAttributeRegex = /content="(.+?)"/;
  var variantsAttributesRegex = /((variants|variantTitles)=".+?")/g;
  Object.entries(templateAnnotations).forEach(function (entry) {
    var _entry = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__["default"])(entry, 2),
      path = _entry[0],
      comment = _entry[1];
    if (selectedVariantRegex.test(comment) && path in selectedComponentVariants) {
      var selectedVariant = selectedComponentVariants[path];
      // name of the 'original' variant has to be remapped to the node name
      // get it from the path
      if (selectedVariant === 'original') {
        selectedVariant = path.split('/').pop();
        modified[path] = comment.replace(selectedVariantRegex, "selectedVariant=\"".concat(selectedVariant, "\""));
      } else {
        // in case of variant, use the variant's template annotation and replace content and variants from original
        var variantPath = path + '/variants/' + selectedVariant;
        var variant = templateAnnotations[variantPath];
        if (variant != null) {
          modified[path] = variant.replace(contentAttributeRegex, comment.match(contentAttributeRegex)[0]);
          modified[path] = modified[path].concat(' ', comment.match(variantsAttributesRegex).join(' '));
          modified[path] = modified[path].concat(' ', "selectedVariant=\"".concat(selectedVariant, "\""));
        } else {
          _LoggerService__WEBPACK_IMPORTED_MODULE_3__["default"].warn('Cannot find the variant with path \'%s\'. Please review the document https://docs.magnolia-cms.com/headless/spa-development/personalization-of-headless-SPA-projects.html#_notes.', variantPath);
        }
      }
    }
  });
  // merge the template annotations with modified annotations
  return _objectSpread(_objectSpread({}, templateAnnotations), modified);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  getVariant: getVariant,
  wrap: wrap
});

/***/ }),

/***/ "./src/service/TemplateAnnotations.js":
/*!********************************************!*\
  !*** ./src/service/TemplateAnnotations.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "getAreaCommentString": () => (/* binding */ getAreaCommentString),
/* harmony export */   "getComponentCommentString": () => (/* binding */ getComponentCommentString),
/* harmony export */   "getPageCommentString": () => (/* binding */ getPageCommentString)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");


var ACTIVATION_STATUS_NOT_ACTIVATED = 0;
var ACTIVATION_STATUS_MODIFIED = 1;
var ACTIVATION_STATUS_ACTIVATED = 2;
var VALUE_PROCESSORS = {
  content: getContentPath,
  availableComponents: getAvailableComponents,
  showAddButton: canAddMoreComponents,
  activationStatus: getActivationStatus
};
var PAGE_MAP = {
  content: ['@path', ''],
  dialog: ['dialog', '', getValueFromObject]
};
var AREA_MAP = {
  name: ['@name', ''],
  content: PAGE_MAP.content,
  dialog: PAGE_MAP.dialog,
  availableComponents: ['availableComponents', []],
  type: ['type', 'list', getValueFromObject],
  label: ['title', '', getValueFromObject],
  inherit: ['inheritance', false, getValueFromObject],
  optional: ['optional', false, getValueFromObject],
  createdAreaNode: ['createAreaNode', true, getValueFromObject],
  showAddButton: ['maxComponents', true],
  showNewComponentArea: [null, true],
  description: ['description', '', getValueFromObject],
  activationStatus: [null, 0]
};
var COMPONENT_MAP = {
  content: PAGE_MAP.content,
  dialog: PAGE_MAP.dialog,
  label: ['title', '', getValueFromObject],
  description: ['description', '', getValueFromObject],
  activationStatus: [null, 0]
};
function getCommentString(data, map, templateDefinition, customParams) {
  var result = [];
  Object.keys(map).forEach(function (key) {
    var _map$key = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__["default"])(map[key], 3),
      dataKey = _map$key[0],
      defaultValue = _map$key[1],
      getDataFn = _map$key[2];
    var contentProcessor = VALUE_PROCESSORS[key];
    var value = defaultValue;
    if (contentProcessor) {
      value = contentProcessor(data, dataKey, templateDefinition, customParams);
    } else if (getDataFn) {
      value = getDataFn(templateDefinition, dataKey, defaultValue);
    } else if (data != null && dataKey !== null) {
      value = data[dataKey] || '';
    }
    var item = {
      key: key,
      value: value
    };
    if (typeof item.value !== 'string' || item.value) {
      result.push("".concat(key, "=\"").concat(item.value, "\""));
    }
  });
  return result.join(' ');
}
function getAvailableComponents(area, dataKey, templateDefinition) {
  if (!templateDefinition || !templateDefinition[dataKey]) {
    return '';
  }
  return Object.keys(templateDefinition[dataKey]).map(function (key) {
    return templateDefinition[dataKey][key].id;
  }).join(',');
}
function canAddMoreComponents(area, dataKey, templateDefinition, customParams) {
  if (!templateDefinition || templateDefinition.maxComponents == null || !customParams || customParams.componentCount == null) {
    return true;
  }
  return customParams.componentCount < templateDefinition.maxComponents;
}
function getValueFromObject(obj, key, defaultValue) {
  var value = obj && (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(obj) === 'object' && key ? obj[key] : null;
  value = value == null ? defaultValue : value;
  value = typeof defaultValue === 'boolean' ? Boolean(value) : value;
  return value != null ? value : defaultValue;
}
function getContentPath(data, key) {
  var value = data ? data[key] : null;
  // NOTE: Empty string is acceptable. So we need check value != null
  return value != null ? "website:".concat(value) : '';
}
function generateMissingAreas(content, templateAnnotations) {
  if (!content || !templateAnnotations) {
    return content;
  }
  var decoratedContent = JSON.parse(JSON.stringify(content));
  Object.keys(templateAnnotations).forEach(function (key) {
    if (key.includes(content === null || content === void 0 ? void 0 : content['@path']) && templateAnnotations[key].startsWith('cms:area')) {
      var areaName = key.split('/').pop();
      if (!(areaName in content)) {
        decoratedContent[areaName] = {
          '@path': "".concat(content === null || content === void 0 ? void 0 : content['@path'], "/").concat(areaName),
          '@nodes': [],
          '@id': "".concat(content === null || content === void 0 ? void 0 : content['@path'], "/").concat(areaName)
        };
      }
    }
  });
  return decoratedContent;
}
function getActivationStatus(data) {
  if (!data || !data['mgnl:activationStatus'] || data['mgnl:activationStatus'] === 'false') {
    return ACTIVATION_STATUS_NOT_ACTIVATED;
  }
  var lastModified = data['mgnl:lastModified'] ? new Date(data['mgnl:lastModified']) : null;
  var lastActivated = data['mgnl:lastActivated'] ? new Date(data['mgnl:lastActivated']) : null;
  return lastModified && lastActivated && lastModified.getTime() > lastActivated.getTime() ? ACTIVATION_STATUS_MODIFIED : ACTIVATION_STATUS_ACTIVATED;
}
var getPageCommentString = function getPageCommentString(page, templateDefinition) {
  return "cms:page ".concat(getCommentString(page, PAGE_MAP, templateDefinition));
};
var getAreaCommentString = function getAreaCommentString(area, templateDefinition, componentCount) {
  var customParams = {
    componentCount: componentCount
  };
  var areaTemplateDefinition = templateDefinition && templateDefinition.areas ? templateDefinition.areas[area['@name']] : {};
  return "cms:area ".concat(getCommentString(area, AREA_MAP, areaTemplateDefinition, customParams));
};
var getComponentCommentString = function getComponentCommentString(component, templateDefinition) {
  return "cms:component ".concat(getCommentString(component, COMPONENT_MAP, templateDefinition));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  getAreaCommentString: getAreaCommentString,
  getComponentCommentString: getComponentCommentString,
  getPageCommentString: getPageCommentString,
  generateMissingAreas: generateMissingAreas
});

/***/ }),

/***/ "./src/service/index.js":
/*!******************************!*\
  !*** ./src/service/index.js ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EditorContextHelper": () => (/* reexport safe */ _EditorContextHelper__WEBPACK_IMPORTED_MODULE_1__["default"]),
/* harmony export */   "LoggerService": () => (/* reexport safe */ _LoggerService__WEBPACK_IMPORTED_MODULE_2__["default"]),
/* harmony export */   "PageEditorBridge": () => (/* reexport safe */ _PageEditorBridge__WEBPACK_IMPORTED_MODULE_4__["default"]),
/* harmony export */   "PersonalizationService": () => (/* reexport safe */ _PersonalizationService__WEBPACK_IMPORTED_MODULE_3__["default"]),
/* harmony export */   "TemplateAnnotations": () => (/* reexport safe */ _TemplateAnnotations__WEBPACK_IMPORTED_MODULE_0__["default"])
/* harmony export */ });
/* harmony import */ var _TemplateAnnotations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TemplateAnnotations */ "./src/service/TemplateAnnotations.js");
/* harmony import */ var _EditorContextHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./EditorContextHelper */ "./src/service/EditorContextHelper.js");
/* harmony import */ var _LoggerService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./LoggerService */ "./src/service/LoggerService.js");
/* harmony import */ var _PersonalizationService__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PersonalizationService */ "./src/service/PersonalizationService.js");
/* harmony import */ var _PageEditorBridge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./PageEditorBridge */ "./src/service/PageEditorBridge.js");






/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/regeneratorRuntime.js":
/*!*******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/regeneratorRuntime.js ***!
  \*******************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/typeof.js":
/*!*******************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
  \*******************************************************/
/***/ ((module) => {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/regenerator/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/@babel/runtime/regenerator/index.js ***!
  \**********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(/*! ../helpers/regeneratorRuntime */ "./node_modules/@babel/runtime/helpers/regeneratorRuntime.js")();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js":
/*!*********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _arrayLikeToArray)
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js":
/*!*******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js ***!
  \*******************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _arrayWithHoles)
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js":
/*!*********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _asyncToGenerator)
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!*******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \*******************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _defineProperty)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js");

function _defineProperty(obj, key, value) {
  key = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__["default"])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js":
/*!*************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js ***!
  \*************************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _iterableToArrayLimit)
/* harmony export */ });
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js":
/*!********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js ***!
  \********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _nonIterableRest)
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js ***!
  \******************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _slicedToArray)
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayWithHoles.js */ "./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js");
/* harmony import */ var _iterableToArrayLimit_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./iterableToArrayLimit.js */ "./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js");
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js");
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./nonIterableRest.js */ "./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js");




function _slicedToArray(arr, i) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__["default"])(arr) || (0,_iterableToArrayLimit_js__WEBPACK_IMPORTED_MODULE_1__["default"])(arr, i) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__["default"])(arr, i) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__["default"])();
}

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/toPrimitive.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js ***!
  \****************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _toPrimitive)
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/esm/typeof.js");

function _toPrimitive(input, hint) {
  if ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js ***!
  \******************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _toPropertyKey)
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _toPrimitive_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./toPrimitive.js */ "./node_modules/@babel/runtime/helpers/esm/toPrimitive.js");


function _toPropertyKey(arg) {
  var key = (0,_toPrimitive_js__WEBPACK_IMPORTED_MODULE_1__["default"])(arg, "string");
  return (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(key) === "symbol" ? key : String(key);
}

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!***********************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \***********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _typeof)
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js ***!
  \*******************************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _unsupportedIterableToArray)
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(o, minLen);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EditorContextHelper": () => (/* reexport safe */ _service__WEBPACK_IMPORTED_MODULE_0__.EditorContextHelper),
/* harmony export */   "LoggerService": () => (/* reexport safe */ _service__WEBPACK_IMPORTED_MODULE_0__.LoggerService),
/* harmony export */   "PageEditorBridge": () => (/* reexport safe */ _service__WEBPACK_IMPORTED_MODULE_0__.PageEditorBridge),
/* harmony export */   "PersonalizationService": () => (/* reexport safe */ _service__WEBPACK_IMPORTED_MODULE_0__.PersonalizationService),
/* harmony export */   "TemplateAnnotations": () => (/* reexport safe */ _service__WEBPACK_IMPORTED_MODULE_0__.TemplateAnnotations)
/* harmony export */ });
/* harmony import */ var _service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./service */ "./src/service/index.js");

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
